import GenericRequest, { METHOD_GET } from '../../../../webservices/GenericRequest';

export class QrMachineTokenTask extends GenericRequest {

    _request; // QrMachineTokenRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/machine-qr/QrMachineTokenTask.js